import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

export function useGetEverifyCompanies({
  search = "",
  isActive = null,
  enabled,
  headers,
} = {}) {
  return useQuery({
    // queryKey MUST use primitive values only (strings, numbers, booleans)
    queryKey: ["everifyCompanies", search, isActive],
    enabled,

    queryFn: async () => {
      const { data } = await api.post(
        "/everifycompany/getallcompanies",
        {
          isPagination: false,
          pageNumber: 1,
          pageSize: 2000,
          isActive: isActive,
          isParent: null,
          search: search,
          sortColumn: "CompanyName",
          sortOrder: "Asc",
        },
        headers ? { headers } : undefined
      );

      // result is already an array, not JSON string
      if (Array.isArray(data.result)) return data.result;

      // fallback if backend returns a string sometimes
      try {
        return JSON.parse(data.result);
      } catch {
        return [];
      }
    },

    staleTime: 1000 * 60 * 5, // 5 minutes cache
    refetchOnWindowFocus: false,
  });
}